import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'projects/ProjetoBaseAngular/app/shared.module';
import { CargoModalComponent } from './cargo-modal/cargo-modal.component';
import { CargoComponent } from './cargo.component';
import { GaleriaModule } from 'projects/ProjetoBaseAngular/app/admin/galeria/galeria.module';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    GaleriaModule
  ],
  declarations: [
    CargoComponent,
    CargoModalComponent
  ]
})
export class CargoModule { }
